module.exports = __webpack_public_path__ + "static/person-bubble-4-96673ac33c8d3849df9a1759f24df27a.png";